import styled from "styled-components";
import { useSelector } from "react-redux";

// import { Default } from "Types";
import { ReduxStates } from "Types";
import { Data as DataType } from "Types/Reducers";

import AtomTitle from "Components/Atoms/Title";
import OrganismForm from "Components/Organisms/Form2";
import OrganismSteps from "Components/Organisms/Steps";
import AtomButton from "Components/Atoms/Button";

export type PropsType = any;

const Wrap = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
`;

const Form = styled(OrganismForm)`
   margin-top: 50px;
`;
const Button = styled(AtomButton)`
   margin-top: 35px;
`;
const Steps = styled(OrganismSteps)`
   margin-top: 45px;
`;

export default function TemplateStep2(props: PropsType) {
   const data = useSelector((state: any) => state.data);
   console.log("dat", data);
   const buttonDisabled = data.v_name && data.email && data.hp && data.name && data.museum && data.startdate && data.enddate && data.runtime;
   return (
      <Wrap>
         <AtomTitle>전시회 등록</AtomTitle>
         <Steps step={2}></Steps>
         <Form data={props.data}></Form>
         <Button onClick={props.nextOnClick} disabled={!buttonDisabled}>
            다음
         </Button>
      </Wrap>
   );
}
